import React from "react";
import "./App.css";
import Providers from "./contexts/Providers";
import Layout from "./components/Layout";
import esriConfig from "@arcgis/core/config.js"
import { useAnalytics } from "./hooks/useAnalytics";
function App() {
  
  useAnalytics()
  esriConfig.portalUrl = 'https://gis.tplgis.org/portal'
  return (
    <Providers>
      <Layout />
    </Providers>
  );
}

export default App;
